@if (showWithLayout) {
  @defer (on timer(5000)) {
    <app-cookie-consent />
    <app-notification />
  }

  @if (showShell) {
    @defer (when showShell; hydrate on interaction) {
      <app-header />
    }
  }

  <div class="main-content" style="min-height: 80vh">
    @if (notFound) {
      @defer (when notFound) {
        <app-error404 />
      } @placeholder {
        <div></div>
      }
    } @else {
      <router-outlet></router-outlet>
      <router-outlet name="modal"></router-outlet>
      <router-outlet name="sideBar"></router-outlet>
    }
  </div>
  @if (showShell) {
    <div style="min-height: 1px">
      @defer (on viewport; hydrate on interaction) {
        <app-footer />
      } @placeholder {
        <div></div>
      }
      @if (!this.partner?.length) {
        @defer (on timer(5000)) {
          <app-melibo />
        }
      }
    </div>
  }
}
